import {
  SaveMedicareQuoteMutation,
  SaveMedicareQuoteMutationVariables,
  useSaveMedicareQuoteMutation,
} from '@coverright/data-access/medicare';
import { MutationHookOptions } from '@apollo/client';

export const useSaveMedicareQuote = (
  options?: MutationHookOptions<
    SaveMedicareQuoteMutation,
    SaveMedicareQuoteMutationVariables
  >
) => {
  return useSaveMedicareQuoteMutation({
    refetchQueries: ['medicareQuote'],
    ...options,
  });
};
